import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RatingData, RatingState } from '../types/ratingTypes';

const initialRatingState: RatingState = {
    selectedRating: 0,
    rating: 0,
    isUsrVoted: false,
    isOwnAttempt: false,
    ratingPercent: 0,
    saved: false,
};

const testRatingSlice = createSlice({
    name: 'testRating',
    initialState: initialRatingState,
    reducers: {
        setCurrentRating(state: RatingState, action: PayloadAction<RatingData>) {
            state.rating = Math.round(action.payload.rating * 10) / 10;
            state.ratingPercent = action.payload.ratingPercent;
            state.isUsrVoted = action.payload.isUsrVoted;
            state.isOwnAttempt = action.payload.isOwnAttempt;
        },

        setSelectedRating(state: RatingState, action: PayloadAction<number>) {
            state.selectedRating = action.payload;
        },

        setIsRatingSaved(state: RatingState, action) {
            state.saved = action.payload;
        },

    },
});

export const {
    setSelectedRating,
    setCurrentRating,
    setIsRatingSaved
} = testRatingSlice.actions;
export default testRatingSlice.reducer;